<template>
  <div>
    <h1 class="mt-0 mb-15 text-center bold-text">Create Your Account</h1>
    <form>
      <base-input
        v-model="credentials.email"
        id="email"
        label="Business email"
        :error="errors['email']"
        required
      />

      <base-input
        v-model="credentials.username"
        id="username"
        label="Username"
        :error="errors['username']"
        required
      />

      <base-input
        v-model="credentials.password"
        id="password"
        label="Password"
        type="password"
        :error="errors['password']"
        required
      />

      <base-input
        v-model="credentials.passwordConfirmation"
        id="passwordConfirmation"
        label="Password confirmation"
        type="password"
        :error="errors['passwordConfirmation']"
        required
      />

      <div class="checkbox">
        <label>
          <input v-model="termsChecked" type="checkbox" /> I agree to the
          <a href="https://www.capsim.com/terms?tab-3" target="_blank">terms of use</a> and
          <a href="https://www.capsim.com/privacy-policy" target="_blank" class="required"
            >privacy policy</a
          >
        </label>
      </div>
      <button :disabled="!termsChecked" data-testid="account-creation-btn" @click.prevent="nextStep" class="btn btn-primary">
        Continue
      </button>
    </form>
  </div>
</template>

<script>
  export default {
    props: {
      errors: {
        type: Object,
        default: () => ({}),
      },
    },
    data() {
      return {
        credentials: {
          email: '',
          username: '',
          password: '',
          passwordConfirmation: '',
        },
        termsChecked: false,
      };
    },

    methods: {
      validateCredentials() {
        const errors = {};
        if (this.credentials.username.length < 6)
          errors['username'] = 'Username should have a minimum of 6 characters';
        if (!/\S+@\S+\.\S+/.test(this.credentials.email))
          errors['email'] = 'Please enter a valid email';
        if (this.credentials.password < 6)
          errors['password'] = 'Password should have a minimum of 6 characters';
        if (this.credentials.passwordConfirmation !== this.credentials.password)
          errors['passwordConfirmation'] = 'Password confirmation should match the password';

        return errors;
      },

      nextStep() {
        this.$emit('error', this.validateCredentials());
        if (Object.keys(this.errors).length) return;

        this.$emit('next', { credentials: this.credentials, termsChecked: this.termsChecked });
      },
    },
  };
</script>

<style lang="scss" scoped>
  .required::after {
    content: '*';
    color: red;
  }
</style>
